import { c as _c } from "react/compiler-runtime";
import type { StructuredContentDocument } from '../../types';
export type AnchorLinkTargetProps = StructuredContentDocument<{
  target: string;
}>;
export const AnchorLinkTarget = t0 => {
  const $ = _c(2);
  const {
    props: t1
  } = t0;
  const {
    target
  } = t1;
  let t2;
  if ($[0] !== target) {
    t2 = <div id={target} />;
    $[0] = target;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};